<div *ngIf="errType !== 'embed'" class="wrapper">
  <div class="container">
    <app-shared-loading text="Reauthenticating user..."></app-shared-loading>
  </div>
</div>

<div *ngIf="errType === 'embed'" class="p-4">
  <app-shared-loading
    text="Reauthenticating user..."
    position="left"
  ></app-shared-loading>
</div>
